import React, { useState, useEffect } from 'react';
import './Navbar.css';

const links = [
  { label: 'Home',      id: 'hero' },
  { label: 'About',     id: 'about' },
  { label: 'Services',  id: 'services' },
  { label: 'Countries', id: 'countries' },
  { label: 'FAQ',       id: 'faq' },
  { label: 'Contact',   id: 'contact' },
];

const icons = {
  'Home': 'fa-house', 'About': 'fa-circle-info', 'Services': 'fa-briefcase',
  'Countries': 'fa-earth-asia',
  'FAQ': 'fa-circle-question', 'Contact': 'fa-envelope',
};

export default function Navbar() {
  const [scrolled, setScrolled]   = useState(false);
  const [open, setOpen]           = useState(false);
  const [active, setActive]       = useState('hero');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      // highlight active section
      const sections = links.map(l => document.getElementById(l.id)).filter(Boolean);
      let current = 'hero';
      sections.forEach(s => {
        if (window.scrollY >= s.offsetTop - 120) current = s.id;
      });
      setActive(current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setOpen(false);
  };

  return (
    <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
      <div className="container">
        <div className="nav-inner">
          <div className="nav-logo" onClick={() => go('hero')} aria-label="RoamLife home">
            <img src="/roamlife-logo.jpeg" alt="RoamLife" />
          </div>

          <ul className="nav-links">
            {links.map(l => (
              <li key={l.id}>
                <button
                  className={active === l.id ? 'active' : ''}
                  onClick={() => go(l.id)}
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>

          <div className="nav-actions">
            <button className="btn btn-teal btn-sm" onClick={() => go('contact')}>
              Apply Now
            </button>
          </div>

          <button
            className="nav-burger"
            onClick={() => setOpen(o => !o)}
            aria-label="Menu"
          >
            <i className={`fas ${open ? 'fa-xmark' : 'fa-bars'}`}></i>
          </button>
        </div>
      </div>

      <div className={`nav-drawer${open ? ' open' : ''}`}>
        <div className="nav-drawer-inner">
          {links.map(l => (
            <button key={l.id} onClick={() => go(l.id)}>
              <i className={`fas ${icons[l.label]}`}></i>
              {l.label}
            </button>
          ))}
          <div className="drawer-cta">
            <button className="btn btn-teal btn-lg" onClick={() => go('contact')}>
              Apply Now
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
